import { lumiApi } from "../index";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getDrivers: build.mutation({
            query: ({
                id,
                score_field,
                concept_selector,
                filter = null,
                match_type,
            }) => {
                const body = {
                    concept_selector,
                    filter,
                    match_type,
                    score_field,
                };
                return {
                    url: `/projects/${id}/concepts/score_drivers`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),

        getDriversBreakdown: build.mutation({
            query: ({
                id,
                score_field,
                concept_selector,
                filter = null,
                match_type,
                breakdowns = [],
            }) => {
                const body = {
                    concept_selector,
                    filter,
                    match_type,
                    score_field,
                    breakdowns,
                };

                return {
                    url: `/projects/${id}/concepts/score_drivers_breakdown`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
    }),
});

export const { useGetDriversMutation, useGetDriversBreakdownMutation } =
    projectsApi;
